import { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLoginV2 = Loadable(lazy(() => import('views/pages/authentication/authentication3/LoginV2')));
const PasswordRecoveryV2 = Loadable(lazy(() => import('views/pages/authentication/authentication3/PasswordRecoveryV2')));
const PasswordResetV2 = Loadable(lazy(() => import('views/pages/authentication/authentication3/PasswordResetV2')));
const SettingUpAccount = Loadable(lazy(() => import('views/pages/authentication/authentication3/SettingUpAccount')));
const ConfirmRegisterUser = Loadable(lazy(() => import('views/pages/authentication/authentication3/ConfirmRegisterUser')));
const PublicProfilePage = Loadable(lazy(() => import('views/pages/public-profile-page')));
const RegistrationV2Page = Loadable(lazy(() => import('views/pages/registration-v2-page')));

// redirects legacy /register-v2 links (and any query params) to /register
const RegisterV2Redirect = () => {
    const location = useLocation();
    return <Navigate to={`/register${location.search}`} replace />;
};

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <AuthLoginV2 />
        },
        {
            path: '/register',
            element: <RegistrationV2Page />
        },
        {
            path: '/register-v2',
            element: <RegisterV2Redirect />
        },
        {
            path: '/password-recovery',
            element: <PasswordRecoveryV2 />
        },
        {
            path: '/password-reset/:userId/:token',
            element: <PasswordResetV2 />
        },
        {
            path: '/setting-up-account/:userId/:token',
            element: <SettingUpAccount />
        },
        {
            path: '/confirm-register-user/:userId/:token',
            element: <ConfirmRegisterUser />
        },
        {
            path: '/public-funder/:profileId',
            element: <PublicProfilePage />
        }
    ]
};

export default AuthenticationRoutes;
